<article class="voice-offering-selector">
  <header>Velg abonnement</header>
  <mat-form-field appearance="outline" class="form-field-with-background ice-custom-mat-select form-field-margin">
    <mat-select
      id="selectVoiceOffering"
      [errorStateMatcher]="matcher"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="selectedOptionId"
      (selectionChange)="onSelectedOfferingChanged()"
    >
      <mat-select-trigger>
        <div class="selected-subscription">
          @if (existingVoiceProduct) {
            <span
              [matTooltip]="
                existingVoiceProduct.offering?.name ||
                existingVoiceProduct.assignedSubscription?.mobilePlan?.productDetails.name ||
                existingVoiceProduct.subscription?.productName ||
                ''
              "
            >
              {{
                existingVoiceProduct.offering?.name ||
                  existingVoiceProduct.assignedSubscription?.mobilePlan?.productDetails.name ||
                  existingVoiceProduct.subscription?.productName
              }}
              - {{ existingVoiceProduct.subscription?.msisdn }}
            </span>
          } @else {
            @if (
              getVasProductFromOffering(selectedNewOffering) && getMobilePlanProductFromOffering(selectedNewOffering);
              as mobilePlanProduct
            ) {
              <span [matTooltip]="mobilePlanProduct?.productName || ''">{{ mobilePlanProduct?.productName }}</span>
              <span>
                {{ mobilePlanProduct.monthlyPrice.price | priceFormat: PriceType.Monthly }}
              </span>
            } @else {
              <span [matTooltip]="selectedNewOffering?.name || ''">{{ selectedNewOffering?.name }}</span>
              <span>{{ selectedNewOffering?.monthlyPrice.price | priceFormat: PriceType.Monthly }}</span>
            }
          }
        </div>
      </mat-select-trigger>
      <div class="ice-custom-mat-options">
        @if (
          existingProductsAvailableForEquipmentUpgrade.length > 0 ||
          existingProductsNotAvailableForEquipmentUpgrade.length > 0
        ) {
          <mat-optgroup label="Behold eksisterende abonnement">
            @for (voiceProduct of existingProductsAvailableForEquipmentUpgrade; track voiceProduct.id) {
              <mat-option [value]="voiceProduct.id">
                <div class="equipment-upgrade-offering-option">
                  <div class="offering-option-name">
                    {{
                      voiceProduct.assignedSubscription?.mobilePlan?.productDetails.name ||
                        voiceProduct.subscription?.productName
                    }}
                    -
                    {{ voiceProduct.subscription?.msisdn }}
                    @if (voiceProduct.offering?.name) {
                      <span>(handlekurv)</span>
                    }
                  </div>
                </div>
              </mat-option>
            }
            @for (voiceProduct of existingProductsNotAvailableForEquipmentUpgrade; track voiceProduct.id) {
              <mat-option matTooltip="Abonnement ikke tilgjengelig" [disabled]="true" [value]="voiceProduct.subscription.id">
                <div class="equipment-upgrade-offering-option">
                  <div class="offering-option-name">
                    {{
                      voiceProduct.assignedSubscription?.mobilePlan?.productDetails.name ||
                        voiceProduct.subscription.productName
                    }}
                    -
                    {{ voiceProduct.subscription.msisdn }}
                  </div>
                </div>
              </mat-option>
            }
          </mat-optgroup>
        }
        <mat-optgroup label="Oppgrader eller opprett nytt abonnement">
          @for (offering of equipmentUpgradeCompatibleOfferings; track offering.id) {
            <mat-option [value]="offering.id">
              @if (getVasProductFromOffering(offering); as vasProduct) {
                <div class="vas-offering-option">
                  <div>
                    <span>
                      {{ getMobilePlanProductFromOffering(offering).productName }}
                    </span>
                    <span>
                      {{ getMobilePlanProductFromOffering(offering).monthlyPrice?.price | priceFormat: PriceType.Monthly }}
                    </span>
                  </div>
                  <div>
                    <span>{{ vasProduct.productName }}</span>
                    <span>
                      @if (vasProduct.monthlyPrice?.price?.includingVAT > 0) {
                        <span>&ensp;+</span>
                      }
                      {{ vasProduct.monthlyPrice?.price | priceFormat: PriceType.Monthly : 'Inkludert' }}
                    </span>
                  </div>
                </div>
              } @else {
                <div class="equipment-upgrade-offering-option">
                  <div class="offering-option-name">{{ offering.name }}</div>
                  <div class="offering-option-price">
                    {{ offering.monthlyPrice?.price | priceFormat: PriceType.Monthly }}
                  </div>
                </div>
              }
            </mat-option>
          }
        </mat-optgroup>
      </div>
    </mat-select>
  </mat-form-field>
</article>
